module.exports = __webpack_public_path__ + "static/media/buy1.7d889a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/buy/buy1.png
// module id = 1295
// module chunks = 0